// deps
import React from "react";

// internal-deps
import { Sdk } from "@client/includes/NativeBridgeSdk";
import { NativeBridge } from "@swiggy-private/native-bridge";
import { CheckoutMain, CheckoutMainProps } from "@swiggy-private/checkout-main";

// styles
import { Container } from "../App/styled";
import { WEB_FOOD_CART_PAYMENT_CONFIG_STORAGE_KEY } from "@client/constants";
import { LocalStorage, isEmpty } from "@swiggy-private/core-ui";
import { GlobalDisableCopyPaste } from "../styles/Global";

type Dict<T> = { [header: string]: T | undefined };

interface CheckoutProps {
    apiHost: string;
    paymentHost: string;
    analyticsHost: string;
    headers: Dict<string>;
    path: string;
    simplPostLinkingRedirectUrl: string;
}

function getQueryParams(path: string): URLSearchParams {
    const segments = path.split("?");
    return new URLSearchParams(segments[1] || "");
}

function getCheckoutProps(props: CheckoutProps): CheckoutMainProps {
    const { apiHost, analyticsHost, paymentHost, headers, path, simplPostLinkingRedirectUrl } = props;
    const queryParams = getQueryParams(path);
    let paymentConfig: Record<string, unknown> = {};
    try {
        const storedConfig = LocalStorage.getItem(WEB_FOOD_CART_PAYMENT_CONFIG_STORAGE_KEY, {});
        paymentConfig = storedConfig ?? {};
    } catch (error) {
        console.error("Error: getting payment config", error);
    }

    const updatedPaymentconfig = !isEmpty(paymentConfig)
        ? { ...paymentConfig, enableWebviewRefreshCapability: true, cachePaymentData: true }
        : {
              apiHost,
              paymentHost,
              analyticsHost,
              simplPostLinkingRedirectUrl,
              enableWebviewRefreshCapability: true,
          };
    return {
        nativeBridgeSdk: Sdk as NativeBridge,
        config: updatedPaymentconfig as CheckoutMainProps["config"],
        headers: headers as CheckoutMainProps["headers"],
        initialState: {
            state: queryParams.get("state"),
            routeData: { groupCartId: queryParams.get("group_cart_id") },
        } as CheckoutMainProps["initialState"],
    };
}

export function Checkout(props: CheckoutProps): React.ReactElement {
    const checkoutProps = getCheckoutProps(props);

    return (
        <>
            <Container>
                <CheckoutMain {...checkoutProps} />
            </Container>
            <GlobalDisableCopyPaste />
        </>
    );
}

export default Checkout;
